import React from 'react'

import { useAuth } from '@fourthwall/auth'
import { Toasts } from '@fourthwall/components'

import type { Values } from './General.types'
import { GeneralView } from './GeneralView'
import { useUserAccountSettingsMutation } from './queries/useUserAccountSettingsMutation'

export const GeneralContainer = () => {
  const { user, updateToken } = useAuth()
  const { userAccountSettingsMutation } = useUserAccountSettingsMutation()

  const handleSubmit = async (values: Values) => {
    try {
      await userAccountSettingsMutation.mutateAsync([values], {
        onSuccess: () => {
          updateToken()
          Toasts.notify('Settings saved.', { type: 'success' })
        },
      })
    } catch (e) {
      Toasts.notify('Failed to save settings.')
    }
  }

  return (
    <GeneralView
      initialValues={{
        fullName: user?.fullName || '',
      }}
      loginDetails={{
        email: user?.email || '',
        verified: user?.verified || false,
      }}
      onSubmit={handleSubmit}
    />
  )
}
